import { convertCentsToEuros } from "@jog/shared"
import type { JoggOrder } from "@jog/types"
import type { BooleanField, KeyTextField } from "@prismicio/types"
import { useRouter } from "next/router"
import { useEffect } from "react"

declare global {
    interface Window {
        // sovApplication?: any
        sovIframes?: Array<{
            trafficSourceNumber: string
            trafficMediumNumber: string
            sessionId: string
            timestamp: number
            orderId: string
            orderValue: string
            orderCurrency: string
            usedCouponCode: string
            iframeContainerId: string
        }>
        sovConsumer?: {
            consumerSalutation: string
            consumerFirstName: string
            consumerLastName: string
            consumerEmail: string
        }
    }
}
export const useSovendus = () => {
    const router = useRouter()
    useEffect(() => {
        const sovBanner = document.querySelector(".sov-sticky-banner-dimension")
        if (sovBanner && router.pathname !== "/orders/payment") {
            sovBanner.remove()
        }
    }, [router])
}
export const Sovendus = ({
    order,
    config,
}: {
    order: JoggOrder
    config: { traffic_source_number: KeyTextField; traffic_medium_number: KeyTextField; enable_sovendus: BooleanField }
}) => {
    useEffect(() => {
        if (config.enable_sovendus && config.traffic_source_number && config.traffic_medium_number) {
            if (typeof window !== "undefined") {
                window.sovIframes = window.sovIframes || []
                window.sovIframes.push({
                    trafficSourceNumber: config.traffic_source_number,
                    trafficMediumNumber: config.traffic_medium_number,
                    sessionId: "",
                    timestamp: Date.now(),
                    orderId: order?.orderNumber,
                    orderValue: convertCentsToEuros(order?.subtotal?.centAmount - order?.totalDiscount.centAmount),
                    orderCurrency: "EUR",
                    usedCouponCode: order?.vouchers?.[0]?.code || "",
                    iframeContainerId: "sovendus-container-1",
                })
                window.sovConsumer = {
                    consumerSalutation: "",
                    consumerFirstName: order?.billingAddress?.firstName || "",
                    consumerLastName: order?.billingAddress?.lastName || "",
                    consumerEmail: order?.billingAddress?.email || "",
                }
            }

            const s = document.createElement("script")

            s.type = "text/javascript"
            s.async = true
            s.src = `https://api.sovendus.com/sovabo/common/js/flexibleIframe.js`

            document.body.appendChild(s)
        }
    }, [order, config])

    if (config.enable_sovendus && config.traffic_source_number && config.traffic_medium_number) {
        return <></>
    }

    return <></>
}
